import { useContext } from 'react'
import { ThemeModeContext, ThemeModeContextType } from '../ThemeModeContext'

export const useThemeMode = (): ThemeModeContextType => useContext(ThemeModeContext)
